import { Text } from 'native-base';
import React from 'react';

import AttractionClosedLabel from 'app/components/AttractionClosedLabel';
import ReservationRequirementLabel from 'app/components/ReservationRequirementLabel';
import ReservationTimeLabel from 'app/components/ReservationTimeLabel';
import { AttractionContent } from 'app/hooks/useAttraction';
import { hasSharedAdmissionOffers } from 'app/services/AttractionHelper';
import { AttractionConfig, EntitlementReservation } from 'app/services/GuestCenterService.types';
import { ReservationTextHelper, TranslationHelper } from 'app/services/I18n';
import { AppAttractionGroup, AppLineupAttractionCard } from 'app/services/ProductLineupHelper';

export type LineupAttractionInfoProps = {
  attrConfig: AttractionConfig;
  attrContent: AttractionContent;
  reservation: Maybe<EntitlementReservation>;
  card: AppLineupAttractionCard;
  group: AppAttractionGroup;
  rt: ReservationTextHelper;
  t: TranslationHelper;
};

export default function LineupAttractionInfo({
  attrConfig,
  attrContent,
  card,
  group,
  reservation,
  rt,
  t,
}: LineupAttractionInfoProps) {
  if (attrConfig?.isClosed) {
    return <AttractionClosedLabel attrConfig={attrConfig} fontSize="sm" pt={1} rt={rt} />;
  }

  if (reservation) {
    return <ReservationTimeLabel reservation={reservation} />;
  }

  const canVisit = !card.hasReservation && group.remainingVisits > 0;
  if (canVisit) {
    return <ReservationRequirementLabel attrConfig={attrConfig} fontSize="sm" pt={1} rt={rt} />;
  }

  if (hasSharedAdmissionOffers(attrContent)) {
    return <Text>{t('app_tickets_admission_offer_prompt')}</Text>;
  }

  return null;
}
